import { LucideIcon, icons } from "lucide-react";
import {
  Star,
  Target,
  Heart,
  Briefcase,
  BookOpen,
  Palette,
  Flame,
  Compass,
  Baby,
  Dumbbell,
  Sparkles,
  Shield,
  Music,
  Code,
  GraduationCap,
  Users,
  Lightbulb,
  Mountain,
  Leaf,
  Brain,
  Coffee,
  Camera,
  Globe,
  Rocket,
  Crown,
  Sun,
  Flower2,
  Anchor,
  Headphones,
} from "lucide-react";

// ─── Icon map: string key → Lucide component ───────────────────────────────

export const SPACE_ICON_MAP: Record<string, LucideIcon> = {
  star: Star,
  target: Target,
  heart: Heart,
  briefcase: Briefcase,
  "book-open": BookOpen,
  palette: Palette,
  flame: Flame,
  compass: Compass,
  baby: Baby,
  dumbbell: Dumbbell,
  sparkles: Sparkles,
  shield: Shield,
  music: Music,
  code: Code,
  "graduation-cap": GraduationCap,
  users: Users,
  lightbulb: Lightbulb,
  mountain: Mountain,
  leaf: Leaf,
  brain: Brain,
  coffee: Coffee,
  camera: Camera,
  globe: Globe,
  rocket: Rocket,
  crown: Crown,
  sun: Sun,
  flower: Flower2,
  anchor: Anchor,
  headphones: Headphones,
};

// ─── Picker options (label for accessibility / tooltips) ────────────────────

export const SPACE_ICON_OPTIONS: { key: string; label: string }[] = [
  { key: "star", label: "Star" },
  { key: "target", label: "Target" },
  { key: "heart", label: "Heart" },
  { key: "sparkles", label: "Sparkles" },
  { key: "flame", label: "Flame" },
  { key: "compass", label: "Compass" },
  { key: "lightbulb", label: "Lightbulb" },
  { key: "rocket", label: "Rocket" },
  { key: "crown", label: "Crown" },
  { key: "shield", label: "Shield" },
  { key: "brain", label: "Brain" },
  { key: "baby", label: "Baby" },
  { key: "users", label: "Users" },
  { key: "dumbbell", label: "Dumbbell" },
  { key: "book-open", label: "Book" },
  { key: "graduation-cap", label: "Graduation" },
  { key: "briefcase", label: "Briefcase" },
  { key: "palette", label: "Palette" },
  { key: "music", label: "Music" },
  { key: "code", label: "Code" },
  { key: "camera", label: "Camera" },
  { key: "coffee", label: "Coffee" },
  { key: "globe", label: "Globe" },
  { key: "mountain", label: "Mountain" },
  { key: "leaf", label: "Leaf" },
  { key: "sun", label: "Sun" },
  { key: "flower", label: "Flower" },
  { key: "anchor", label: "Anchor" },
  { key: "headphones", label: "Headphones" },
];

// ─── Preset → icon key mapping ─────────────────────────────────────────────

export const PRESET_ICON_MAP: Record<string, string> = {
  Parent: "baby",
  Leader: "target",
  Partner: "heart",
  Creator: "sparkles",
  Learner: "book-open",
  Athlete: "dumbbell",
  Friend: "users",
  Healer: "leaf",
};

// ─── Helper: kebab-case → PascalCase ("book-open" → "BookOpen") ─────────────

function kebabToPascal(s: string): string {
  return s.split("-").map(w => w.charAt(0).toUpperCase() + w.slice(1)).join("");
}

// ─── Helper: get icon component by name ─────────────────────────────────────

export function getSpaceIcon(iconName?: string): LucideIcon {
  if (!iconName) return Star;
  // Check preset map first
  if (SPACE_ICON_MAP[iconName]) return SPACE_ICON_MAP[iconName];
  // Fall back to full lucide icons (for AI-suggested icons)
  const pascalName = kebabToPascal(iconName);
  if ((icons as Record<string, LucideIcon>)[pascalName]) return (icons as Record<string, LucideIcon>)[pascalName];
  return Star;
}
